import {Injectable, Injector} from '@angular/core';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {PrescriptionModel} from '../../../api/model/prescription.model';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';


@Injectable({providedIn: 'root'})
export class PrescriptionRepository extends AbstractRepositoryV2<PrescriptionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Prescription', serviceElementsFactory, injector);
    }
}
